import React from 'react';
import * as Form from '@radix-ui/react-form';
import { IconSvg } from '../IconSvg';
import './style.css';

interface TranslateInputProps {
  value: string;
  onChange: (value: string) => void;
  onSubmit: () => void;
  loading: boolean;
}

export const TranslateInput: React.FC<TranslateInputProps> = ({
  value,
  onChange,
  onSubmit,
  loading
}) => {
  const handleKeyDown = (e: React.KeyboardEvent) => {
    if (e.key === 'Enter' && !e.shiftKey) {
      e.preventDefault();
      if (!loading && value.trim()) {
        onSubmit();
      }
    }
  };

  return (
    <Form.Root className="translate-form" onSubmit={(e) => {
      e.preventDefault();
      if (!loading && value.trim()) {
        onSubmit();
      }
    }}>
      <Form.Field className="input-field" name="text">
        <Form.Control asChild>
          <textarea
            className="text-input"
            value={value}
            onChange={(e) => onChange(e.target.value)}
            placeholder="请输入中文文本，按回车翻译..."
            disabled={loading}
            onKeyDown={handleKeyDown}
            required
          />
        </Form.Control>
      </Form.Field>
      {loading && (
        <div className="loading-overlay">
          <IconSvg name="eos-icons:loading" width={24} height={24} />
        </div>
      )}
    </Form.Root>
  );
};